var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7995 29.5991C22.9731 29.5991 29.5991 22.9731 29.5991 14.7995C29.5991 6.62598 22.9731 0 14.7995 0C6.62598 0 0 6.62598 0 14.7995C0 22.9731 6.62598 29.5991 14.7995 29.5991Z",
    fill: "#010201"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2536 10.0505C24.0256 9.202 23.3591 8.53328 22.5084 8.30526C20.9692 7.89307 14.7995 7.89307 14.7995 7.89307C14.7995 7.89307 8.6297 7.89307 7.09055 8.30526C6.24204 8.53328 5.57332 9.19981 5.3453 10.0505C4.93311 11.5897 4.93311 14.7995 4.93311 14.7995C4.93311 14.7995 4.93311 18.0094 5.3453 19.5485C5.57113 20.397 6.23985 21.0658 7.09055 21.2938C8.6297 21.706 14.7995 21.706 14.7995 21.706C14.7995 21.706 20.9692 21.706 22.5084 21.2938C23.3569 21.0658 24.0256 20.3992 24.2536 19.5485C24.6658 18.0094 24.6658 14.7995 24.6658 14.7995C24.6658 14.7995 24.6658 11.5875 24.2536 10.0505ZM12.8262 17.7594V11.8396L17.9523 14.7995L12.8262 17.7594Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeCircle);
export default __webpack_public_path__ + "static/media/youtube_circle.d220077f4c44e89c481140b9375b610c.svg";
export { ForwardRef as ReactComponent };